import "styles/index.css";

import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import mainAction from "../modules/main/actions";
import mainSelectors from "../modules/main/selectors";
import styled from "styled-components";
import colors from "../styles/colors";
import { useTranslation } from "react-i18next";

const Loading = () => {
  let history = useHistory();
  const location = useLocation();
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const currentDashboardResult = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const dispatch = useDispatch();
  const firstLoad = useRef(true);
  const [t] = useTranslation();
  const { REACT_APP_RMP_URL, REACT_APP_RCRM_APP_ID } = process.env;
  const checkAppAvailableResult = useSelector((state) => mainSelectors.checkAppAvailableResult(state));

  let param = new URLSearchParams(location.search);
  let otp = "";
  let page = "";

  param.forEach((item, key) => {
    if (key === "otp") {
      otp = item;
    } else if (key === "page") {
      page = item;
    } else if (key === "menu") {
      page = item;
    }
  });
  useEffect(() => {
    const rmpToken = sessionStorage.getItem("rmp_token");

    const rmp_widget_js = document.getElementById("rmp_widget_js");
    if (rmp_widget_js) {
      rmp_widget_js.parentNode.removeChild(rmp_widget_js);
    }
    dispatch(mainAction.AuthAdpro(otp, rmpToken));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(mainAction.currentDashboard("google"));

    if (authAdproResult.result === 0 && authAdproResult.data.adwords_managed_service === "N") {
      authAdproResult.result = 1;
    }

    if (authAdproResult.data.adwords_managed_service === "U") {
      authAdproResult.result = 1;
    }

    if ((authAdproResult?.result || authAdproResult?.result === 0) && !checkAppAvailableResult.data?.foundApp) {
      if (authAdproResult?.data?.jwt) {
        dispatch(mainAction.checkAppAvailable({ token: authAdproResult.data.jwt }));
      } else if (sessionStorage.getItem("rmp_token") != "" || sessionStorage.getItem("rmp_token") != null) {
        dispatch(mainAction.checkAppAvailable({ token: sessionStorage.getItem("rmp_token") }));
      }
    }

    // Mock
    // 'Y' = manage service
    // 'N' = self service
    // 'U' = Unknown (self service) ,
    // authAdproResult.result = 1
    // authAdproResult.data.adwords_managed_service = 'U'

    if (firstLoad.current) {
      if (
        authAdproResult.data.adwords_managed_service === "Y" ||
        authAdproResult.data.adwords_managed_service === "U"
      ) {
        history.push("/setting");
      } else {
        firstLoad.current = false;
        return;
      }
    } else if (page === "meta_leads") {
      history.push("/setting/fb");
      dispatch(mainAction.currentDashboard("settings"));
      sessionStorage.setItem("email", "meta_leads");
    } else if (page === "google_leads") {
      history.push("/setting");
      dispatch(mainAction.currentDashboard("settings"));
      sessionStorage.setItem("email", "google_leads");
    } else if (!authAdproResult.result && page === "setting") {
      history.push("/setting");
    } else if (
      !authAdproResult.result &&
      authAdproResult.data.ads &&
      authAdproResult.data.ads.length > 0 &&
      authAdproResult.data.adwords_managed_service === "Y"
    ) {
      //manage service
      history.push("/dashboard");
    } else if (
      authAdproResult.result === 1 &&
      authAdproResult.data.allAds &&
      authAdproResult.data.allAds.length > 0 &&
      (authAdproResult.data.adwords_managed_service === "Y" || authAdproResult.data.adwords_managed_service === "U")
    ) {
      // seft service
      history.push("/wizard");
    } else if (authAdproResult.result === 1 || authAdproResult.result === 2) {
      if (authAdproResult.data.adwords_managed_service === "Y") {
        history.push("/dashboard");
      } else {
        history.push("/dashboard/self-service");
      }
    } else {
      console.log("auth failed go rmp", REACT_APP_RMP_URL);
      window.parent.location = REACT_APP_RMP_URL;
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authAdproResult.result]);

  return <StyledContainer title="Loading">{t("__loading")}</StyledContainer>;
};

export default Loading;

const StyledContainer = styled.div`
  display: flex;
  background-color: ${colors.background};
  height: 100vh;
  justify-content: center;
  align-items: center;
  color: ${colors.subText};
`;
